import { getAxiosClient } from "../../axios-client";
import {
  OfferClientFinalAcceptRequestBody,
  OfferClientFinalAcceptResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const offerClientFinalAccept = async (
  body: OfferClientFinalAcceptRequestBody
) => {
  return await axiosClient.ax.post<OfferClientFinalAcceptResponse>(
    "/Offers/OfferClientFinalAccept",
    body
  );
};
